export var DocumentDelta;
(function (DocumentDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["DOCUMENT_DELTA"] = "document_delta";
    })(type = DocumentDelta.type || (DocumentDelta.type = {}));
})(DocumentDelta || (DocumentDelta = {}));
